module.exports = __webpack_public_path__ + "static/media/06_profile_picture.4c06c4b6.png";